import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";

const API = process.env.REACT_APP_API_URL;

export default function UsermanagementPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        setErr("");
        const res = await fetch(`${API}/org-users`, { credentials: "include" });
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        if (!cancelled) setUsers(Array.isArray(data) ? data : []);
      } catch (e) {
        if (!cancelled) setErr(e?.message || "Fehler beim Laden der Nutzer");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="flex min-h-screen bg-[#cdeaff]">
      <Sidebar active="user-mgmt" />
      <main className="flex-1 px-0 pt-6 pb-0">
        <div className="w-full h-full rounded-tl-xl border border-black/10 bg-white/60 p-6 backdrop-blur">
          <div className="mb-4 flex items-center justify-between">
            <h1 className="text-3xl font-semibold text-gray-900">
              Nutzerverwaltung
            </h1>
          </div>

          {/* Loading / Error */}
          {loading && (
            <div className="text-sm text-gray-700">Lade Nutzer…</div>
          )}
          {err && !loading && (
            <div className="mb-3 rounded-md bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-800">
              {err}
            </div>
          )}

          {/* Empty */}
          {!loading && !err && users.length === 0 && (
            <div className="text-sm text-gray-700">Keine Nutzer gefunden.</div>
          )}

          {/* Table */}
          {!loading && !err && users.length > 0 && (
            <div className="overflow-x-auto rounded-xl border border-black/10 bg-white shadow-sm">
              <table className="min-w-full text-sm">
                <thead className="bg-gray-50 text-gray-700">
                  <tr>
                    <th className="px-4 py-3 text-left font-semibold">Email</th>
                    <th className="px-4 py-3 text-left font-semibold">Rolle</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {users.map((u, idx) => (
                    <tr key={`${u.email}-${idx}`} className="hover:bg-gray-50/60">
                      <td className="px-4 py-3 text-gray-900">{u.email}</td>
                      <td className="px-4 py-3">
                        <span className="inline-flex items-center rounded-full bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-700 border border-blue-200">
                          {u.role || "—"}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

        </div>
      </main>
    </div>
  );
}
